/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BodyInputs */

const cs_field_body = /** @type {(inputs: Field_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah`)
};

const en_field_body = /** @type {(inputs: Field_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

/**
* | output |
* | --- |
* | "Body" |
*
* @param {Field_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_body = /** @type {((inputs?: Field_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_body(inputs)
	return cs_field_body(inputs)
});